@use "./LynePicker.scss";

.people-picker {
  .current-user {
    white-space: nowrap;
    padding-top: 0.3rem;
    padding-right: 0.5rem;
    vertical-align: top;
    line-height: 20px;

    .ms-Icon {
      font-size: 13px;
      margin: 0 0.25rem 0 0.5rem;
    }

    .ms-Persona.ms-Persona--24 .ms-Persona-imageArea {
      height: 20px;
      width: 20px;
    }

    .ms-Persona.ms-Persona--24 .ms-Persona-initials {
      line-height: 20px;
    }

    &:after {
      content: "";
      margin: 0;
      border-left: 1px solid #ccc;
      display: inline-block;
      height: 20px;
      margin-left: 0.5rem;
      margin-bottom: 0.2rem;
      vertical-align: middle;
    }
  }
}
